import {Component, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import * as moment from 'moment';
import {Observable} from 'rxjs';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {PrincipalService} from '../../../shared';
import {Router, NavigationStart, Event as NavigationEvent} from '@angular/router';
import {FundadminService} from '../services/fundadmin.service';
import {IMyDpOptions, IMyDateModel} from 'mydatepicker';
import {DatePickerComponent} from 'ng2-date-picker';
import {FundPerformanceResourceService} from "../../../shared/services/fund-performance-resource.service";

declare var jQuery: any;

@Component({
  selector: 'app-fundadmin',
  templateUrl: './fundadmin.component.html',
  styleUrls: ['./fundadmin.component.css']
})
export class FundadminComponent implements OnInit {
  @ViewChild('monthPicker') datePicker: DatePickerComponent;
  public funds;
  public show;
  public hide;
  public flag;
  public fromDate;
  public toDate;
  public midDate;
  public message;
  public forms;
  public sources;
  public isDayDisabled: boolean = false;
  public submitDisabled: boolean = false;
  public isAdd: boolean = true;
  public errorMessage = "server error";
  public hideModal: boolean = true;
  public endingDate = new Date();
  public yearEdate;
  public monthEdate;
  public dayEdate;
  public searchString = '';
  public lang;
  public langSubscription;
  public singleFund: boolean = false;
  public displayDate;
  public hideEditBtn: boolean = false;
  public showForm: boolean = false;
  public progress: boolean = false;
  public periodYear;
  public getDesc;
  public updateStyle: boolean = false;
  public saveSuccess = false;
  public showDesc = false;
  public datePickerOpened = false;
  public hideForms: boolean = true;
  public noformToEdit: boolean = true;
  max = moment();
  datePickerConfig = {
    drops: 'down',
    format: 'MMM-YYYY',
    closeOnSelect: true,
    disabled: true,
    max: this.max,
    yearFormat: "YYYY",
    disableKeypress: true,
    opens: "right"
  }
  public frDate = moment().add(0, 'months').toDate();
  public toDateVal = moment().toDate();
  period = moment(this.toDateVal, 'jYYYY,jMM,jDD');
  public customFundForm = new FormGroup({
    'fundDate': new FormControl('', Validators.required),
    'fundDateOnModal': new FormControl('', Validators.required),
    'fundStatus': new FormControl('')
  });
  public fundDate: AbstractControl = this.customFundForm.get('fundDate');
  public fundDateOnModal: AbstractControl = this.customFundForm.get('fundDateOnModal');

  constructor(private principalService: PrincipalService,
              private translate: TranslateService,
              public router: Router,
              public fundService: FundadminService,
              private fundPerformanceResourceService: FundPerformanceResourceService,
              public principal: PrincipalService) {
    this.lang = translate.currentLang;
    this.langSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;

    });

  }

  ngOnInit() {
    this.getAllFunds(0);
  }

  dateOpen() {
    this.datePicker.api.open();
  }

  getAllFunds(flag) {
    if (flag == 0) {
      this.saveSuccess = false;
    }
    this.showForm = false;
    this.progress = true;
    this.getFirstLastDay(this.period);
    this.getFormattedDate(this.period);
    this.fundPerformanceResourceService.getHistory(this.searchString, this.fromDate, this.toDate, this.lang).subscribe((fundData) => {
      this.showForm = true;
      this.progress = false;
      if (fundData == '') {
        this.funds = '';
        this.show = false;
        //this.hide denotes that , there is no data available in server for the chosen period so show  'No Data availble message'
        //and hide the history table
        this.isAdd = true;
        this.hide = true;
        //this.flag = 1 represents ADD
        this.flag = 1;
      } else {
        this.hideEditBtn = false;
        this.funds = fundData;
        //this.show denotes that , there is data available in server for the chosen period so show the history
        this.show = true;
        this.hide = false;
        //this.flag = 2 represents EDIT
        this.flag = 2;
      }
      this.getForm(this.flag, 0);
    });
  }

  getForm(flag, edit) {
    this.getFirstLastDay(this.period);
    this.singleFund = false;
    this.fundService.getForm(this.searchString, this.midDate, this.lang, flag).subscribe((data: any) => {
      this.forms = data.funds;
      this.hideForms = true;
      this.noformToEdit = false;
      if (data.funds[0].benchmark == '' && edit == 1) {
        this.hideForms = false;
        this.noformToEdit = true;
      }
      let midDate = this.midDate;
      if (this.forms.length == 1) {
        this.singleFund = true;
      } else {
        this.singleFund = false;
      }
      this.forms.forEach(function (newItem) {
        newItem.entryDate = midDate;
      });
      this.sources = data.benchmarkSources;
      this.getFormattedDate(this.period);
    });

  }

  addFunds() {
    let formIsValid = true;
    this.forms.forEach(function(form) {
      if (form.performance === '' || form.benchmark === '' || form.benchmarkSource === '') {
        formIsValid = false;
      }
      if (isNaN(parseInt(form.performance))) {
        formIsValid = false;
      }
      if (isNaN(parseInt(form.benchmark))) {
        formIsValid = false;
      }
    });

    if (formIsValid) {
      this.fundService.addFunds(this.forms).subscribe(
        data => {
          if (data.status == '200') {
            this.saveSuccess = true;
            this.getAllFunds(1);
            if (this.hide) {
              this.message = "Fund Added Successfully"
            }
            if (this.show) {
              this.message = "Fund Edited Successfully"
            }
          }
        },
        error => {
          this.errorMessage = <any>error;
          this.getAllFunds(0);
        });
    }
  }

  checkSearchString() {
    if (this.searchString != '') {
      this.hideEditBtn = true;
      this.updateStyle = true;
    } else {
      this.updateStyle = false;
    }
  }

  /*
   * Function to get first , mid , last day of chosen date period
   */
  getFirstLastDay(period) {
    var year = moment(period).year()
    var month = moment(period).month()
    var firstDay = new Date(year, month, 1);
    var lastDay = new Date(year, month + 1, 0);
    var midday = new Date(year, month, 15);
    this.fromDate = moment(new Date(firstDay)).format('YYYY-MM-DD');
    this.toDate = moment(new Date(lastDay)).format('YYYY-MM-DD');
    this.midDate = moment(new Date(midday)).format('YYYY-MM-DD');
  }

  clearSearchData() {
    this.period = null;
    this.fundDate.patchValue('');
    this.fundDateOnModal.patchValue('');
    this.yearEdate = 0;
    this.monthEdate = 0;
    this.dayEdate = 0;
    this.submitDisabled = true;
    this.show = false;
    this.hide = true;
    this.isAdd = false;
    this.searchString = '';
  }

  public getFormattedDate(period) {
    let date = period.date;
    var year = date.year;
    var month = date.month;
    month = month > 9 ? month : '0' + month;
    var day = date.day;
    if ((date.day) > 9) {
      day = date.day;
    } else {
      day = '0' + day;
    }
    let genericFomatDate = new Date(year + '-' + month + '-' + day);
    this.displayDate = moment(genericFomatDate).format("MMMM YYYY");
  }
}
